import type { TElement } from "@udecode/plate";
import { PlateNodes } from "../../config/typescript";

export const ELEMENT_END_NOTE = "endnote";

export interface TEndNote extends TElement {
  note: PlateNodes | string | null;
}
